import MapLayer from '../map-layer.enum';
import setPortsLayer from './ports-layer';

function addPortsLayer(layer: MapLayer | string, metadata?: {}) {
  return setPortsLayer(layer, metadata);
}

export default addPortsLayer;
